import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ValorCaracteristicaService } from "../../../../providers/valor-caracteristica.service";
import { PipesModule } from "../../../../pipes/pipes.module";
import { MaterialModule } from "../../../../components/material/material.module";
import { CrearValorComponent } from "./crear-valor/crear-valor.component";
import { CrearValorDialog } from "./crear-valor/crear-valor-dialog/crear-valor-dialog.component";
import { EditarValorComponent } from "./editar-valor/editar-valor.component";
import { EditarValorDialog } from "./editar-valor/editar-valor-dialog/editar-valor-dialog.component";
import { EliminarValorComponent } from "./eliminar-valor/eliminar-valor.component";
import { EliminarValorDialog } from "./eliminar-valor/eliminar-valor-dialog/eliminar-valor-dialog.component";
import { ListarValoresComponent } from "./listar-valores/listar-valores.component";
import { ValorCaracteristicaComponent } from "./valor-caracteristica/valor-caracteristica.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        RouterModule,
        MaterialModule,
    ],
    declarations: [
        CrearValorComponent,
        CrearValorDialog,
        EditarValorComponent,
        EditarValorDialog,
        EliminarValorComponent,
        EliminarValorDialog,
        ListarValoresComponent,
        ValorCaracteristicaComponent
    ],
    providers: [
        ValorCaracteristicaService
    ],
    entryComponents: [
        CrearValorDialog,
        EditarValorDialog,
        EliminarValorDialog,
    ],
    exports: [
        CrearValorComponent,
        EditarValorComponent,
        EliminarValorComponent,
        ListarValoresComponent,
        ValorCaracteristicaComponent
    ]
})
export class ValorCaracteristicaModule { }